module.exports = __webpack_public_path__ + "img/zw2.0dbab756.png";